/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Details/Content/Person/Gender"
  
}) {
let personMatchGenderValueData = fromData.useDataValue({ viewPath,
context: 'person_match',
path: 'gender',
})
let gendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
})
let aggregateData = fromHelpers.getValue(personMatchGenderValueData, gendersValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Gender.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Gender"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="person_match.gender"
 data="genders"
 aggregate="helpers.js getValue"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}